import { HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { saveAs } from 'file-saver';
import { LoadingOverlayService } from '../shared/loading.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class ApiHttpService {

  apiUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private loading: LoadingOverlayService
  ) { }

  httpOptions: any = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  })

  get(endpoint: string, params?: Object) {
    if (params) {
      endpoint += '?'
      for (let [k, v] of Object.entries(params)) {
        endpoint += `${k}=${v}&`
      }
    }
    return this.http.get<any>(this.apiUrl + endpoint, { headers: this.headers });
  }
  post(endpoint: string, data: any): Observable<any> {
    return this.http.post(this.apiUrl + endpoint, data, this.httpOptions);
  }
  postPDF(endpoint: string, data: any): Observable<any> {
    return this.http.post(this.apiUrl + endpoint, data, { ...this.httpOptions, responseType: 'arraybuffer' });
  }

  downloadPdf(fileName: string) {
    let headerOptions = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/pdf'
      //   'Accept': 'application/octet-stream', // for excel file
    });

    // let requestOptions = {headers : headerOptions,responseType: 'blob' as 'blob'}; 
    // post or get depending on your requirement
    // return this.http.post(url,dataObj,requestOptions).pipe(map((data :any)  => {
    this.http.get(this.apiUrl + 'downloadDocumento', {
      responseType: 'blob',
      params: {
        fileName: fileName
      }
    }).subscribe(data => {
      let blob = new Blob([data], {
        type: 'application/pdf' // must match the Accept type
        // type: 'application/octet-stream' // for excel 
      });

      saveAs(blob, fileName);
    }, err => {
      this.snackBar.open('Errore scaricamento del file', undefined, { panelClass: ['snack-error'], duration: 4000 });
    })
  }

  downloadDocCompilato(id_doc: number, data: any, fileName: string) {
    this.loading.show();
    
    let headerOptions = new HttpHeaders({
      'Content-Type': 'application/json',
      'responseType': 'application/pdf'
      //   'Accept': 'application/octet-stream', // for excel file
    });

    // TODO provvisorio, trovare il modo di parsare una data in stringa, in json stringify per esempio

    if (data['rappLegale']['dataDiNascita']){
      data['rappLegale']['dataDiNascita'] = data['rappLegale']['dataDiNascita'].format('DD/MM/YYYY');
    }
    if (data['amministratore']['dataDiNascita']){
      data['amministratore']['dataDiNascita'] = data['amministratore']['dataDiNascita'].format('DD/MM/YYYY');
    }

    this.http.post(this.apiUrl + 'downloadDocCompilato',
      {
        id_doc: id_doc,
        data: data
      },
      {
        responseType: 'blob',
      }).subscribe(data => {
        this.loading.hide();
        let blob = new Blob([data], {
          type: 'application/pdf' // must match the Accept type
          // type: 'application/octet-stream' // for excel 
        });

        saveAs(blob, fileName);
      }, err => {
        this.loading.hide();
        this.snackBar.open('Errore scaricamento del file', undefined, { panelClass: ['snack-error'], duration: 4000 });
      })
  }

}
